import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { AiToneOfVoice } from "lib/hooks/api/ai_tone_of_voice/useAiToneOfVoices";
import Button from "../../ui/button/Button";

type Props = {
  entry: AiToneOfVoice;
  onEdit: () => void;
  onDelete: () => void;
};

export function ToneOfVoiceRow({ entry, onEdit, onDelete }: Props): JSX.Element {
  return (
    <>
      <Container alignItems="center" gap={8}>
        <Flex alignItems="center" gap={16}>
          <Text bold>{entry.label}</Text>
          {entry.isDefault && <DefaultBadge>Default</DefaultBadge>}
        </Flex>
        <Flex gap={8} alignItems="center">
          <Button icon="edit05" onClick={onEdit} buttonType="tertiary" aria-label="Edit entry" />

          <Button
            icon="trash03"
            disabled={entry.companyId === null}
            onClick={onDelete}
            iconProps={{ color: "sysDestructiveDefault" }}
            buttonType="tertiary"
            aria-label="Delete entry"
          />
        </Flex>
      </Container>
    </>
  );
}

const Container = styled(Flex)(({ theme }) => ({
  padding: "12px 16px",
  border: `1px solid ${theme.colors.sysBorderDecorative}`,
  borderRadius: 8,
  justifyContent: "space-between",
}));

const DefaultBadge = styled(Flex)(({ theme }) => ({
  padding: "4px 12px",
  alignItems: "center",
  background: `${theme.colors.sysTextDefault}14`,
  color: theme.colors.sysTextDefault,
  fontSize: 12,
  boxShadow: "0 0 1px 0 rgba(255, 255, 255, 0.75) inset",
  height: 32,
  width: "fit-content",
  borderRadius: 16,
}));
